<span ngForm #frm="ngForm">
<label *ngIf="label" [ngClass]="labelClass">{{ label }}<span *ngIf="required">*</span></label>
<mat-form-field [ngClass]="styleClass">
    <input  #control matInput id="{{ inputId }}" placeholder="{{ placeholder }}" [appCustomPatternValidator]="fieldValidationConstraints"
            [disabled]="disabled" [(ngModel)] = "result"
            tabindex="{{ tabIndex }}"
            (ngModelChange)="onModelChanged($event)"
            (blur)="onBlur($event)" (keyup.enter)="onEnter()"
            name="{{name}}"  appFormatCurrency [format]="numberFormat" [min]="min" [max]="max" [allowDecimal]="allowDecimal"
            (paste)="onPaste($event)"/>
  <mat-error *ngIf="(this.error ||  frm.controls[name]?.errors?.regexp) && frm.controls[name].invalid && (frm.controls[name].touched || frm.controls[name].dirty) ">
    <ng-container *ngIf="frm.controls[name].errors?.regexp">
      {{ frm.controls[name].errors.regexp }}
    </ng-container>
    <ng-container *ngIf="!frm.controls[name].errors?.regexp">
      {{ error }}
    </ng-container>
  </mat-error>
</mat-form-field>
<span *ngIf="unit">{{ unit }}</span>
</span>

